import { Box, Image } from '@/components';
import type { CSSProperties, FC } from 'react';

type Props = {
  src: string | undefined;
  style?: CSSProperties;
  wrapperStyle?: CSSProperties;
};

export const ImageCell: FC<Props> = ({ src, style, wrapperStyle }) => {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      {...wrapperStyle}
    >
      <Image src={src} style={style} preview={false} />
    </Box>
  );
};
